// Local translations
export const T = {
  en_GB: {
    style: "Style",
    styleNone: "None",
    styleBorder: "Border",
    styleBox: "Box (with background)",
    styleHelp: "Choose how this component is visually styled",
    titleOptional: "Title (optional)",
    titlePlaceholder: "Enter a custom title...",
    descriptionOptional: "Description (optional)",
    descriptionPlaceholder: "Enter a custom description...",
  },
  nb_NO: {
    style: "Stil",
    styleNone: "Ingen",
    styleBorder: "Kantlinje",
    styleBox: "Boks (med bakgrunn)",
    styleHelp: "Velg hvordan denne komponenten skal vises visuelt",
    titleOptional: "Tittel (valgfritt)",
    titlePlaceholder: "Skriv inn en egendefinert tittel...",
    descriptionOptional: "Beskrivelse (valgfritt)",
    descriptionPlaceholder: "Skriv inn en egendefinert beskrivelse...",
  },
} as const;
